import React from 'react'
import { Tooltip } from '@material-ui/core'
import Checkbox from '_/components/checkbox'
import { PERMISSIONS_MESSAGES } from '_/utils/constants/permissions'

export const getFieldValue = (formState, row, field, defaultValue) => {
  return formState?.find(item => item?.id === row?.id)?.[field] ?? defaultValue
}

export const getCheckboxWrapperStyle = isDisabled => ({
  display: 'inline-flex',
  alignItems: 'center',
  borderRadius: 6,
  opacity: isDisabled ? 0.3 : 1,
  cursor: isDisabled ? 'not-allowed' : 'pointer',
})

export const renderPermissionCheckbox = ({
  row,
  value,
  field,
  allowedField,
  formState,
  handleSetValue,
}) => {
  const isDisabled = !row?.[allowedField]
  const checkbox = (
    <span style={getCheckboxWrapperStyle(isDisabled)}>
      <Checkbox
        checked={getFieldValue(formState, row, field, value)}
        disabled={isDisabled}
        name={field}
        onChange={event => handleSetValue(row, event.target?.name, event.target?.value)}
      />
    </span>
  )

  if (!isDisabled) {
    return checkbox
  }

  return <Tooltip title={PERMISSIONS_MESSAGES.UNAVAILABLE_OPTION}>{checkbox}</Tooltip>
}
